<template>
  <div class="my-title">
    <span>{{title}}</span>
    <div class="extra">
      <slot name="extra"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "my-title",
  props: {
    title: {
      type: String,
      default: null
    }
  }
}
</script>
<style lang="less" scoped>
  .my-title {
    >span {
      font-size: 14px;
      font-weight: bold;
      float: left
    }
    .extra {
      float: left;
      margin-left: 16px;
    }
  }
</style>
